import { useOnChangeRef } from '@/features/form/hooks/useOnChangeRef'
import { OnChange } from '@/features/form/types'
import { FormAddonGroup } from '@/features/pos/components/ProductConfigurationModal/form/types'
import { useFormAddonGroupRef } from '@/features/pos/components/ProductConfigurationModal/parts/AddonGroup/hooks/useFormAddonGroupRef'
import AddonQuantitiesAdjuster from '@/features/pos/components/ProductConfigurationModal/services/addonQuantitiesAdjuster'
import { AddonGroup } from '@/features/pos/components/ProductConfigurationModal/types'
import { toFormAddonGroup } from '@/features/pos/components/ProductConfigurationModal/utils/toFormAddonGroup'
import { useCallback } from 'react'

export const useUpdateRepeatableAddon = (
    addonGroup: AddonGroup,
    formAddonGroup: FormAddonGroup,
    onChange: OnChange
): ((addonId: string, quantity: number) => void) => {
    const formAddonGroupRef = useFormAddonGroupRef(formAddonGroup)

    const onChangeRef = useOnChangeRef(onChange)

    return useCallback(
        (addonId: string, quantity: number) => {
            const addonQuantities = AddonQuantitiesAdjuster.getNextRepeatableAddonQuantities(
                formAddonGroupRef.current.addonQuantities,
                addonGroup.maxQuantity,
                addonId,
                quantity
            )

            onChangeRef.current(toFormAddonGroup(addonGroup, addonQuantities))
        },
        [addonGroup, formAddonGroupRef, onChangeRef]
    )
}
